import React from 'react'
import { useTranslation } from 'react-i18next'
import { ColumnDef } from '@tanstack/react-table'
import { DataTable } from '../data-table'

type CsvPreview = {
  headers: string[]
  rows: string[][]
}

type CsvPreviewProps = {
  csvPreview: CsvPreview
  totalRows: number
}

const CSVPreview: React.FC<CsvPreviewProps> = ({ csvPreview, totalRows }) => {
  const { t } = useTranslation()

  // Dynamically create columns from headers
  const columns: ColumnDef<string[]>[] = csvPreview.headers.map(
    (header, index) => ({
      accessorFn: (row) => row[index],
      id: header,
      header: () => (
        <span className="text-xs font-semibold text-gray-300 uppercase break-normal">
          {t(header)}
        </span>
      ),
      cell: (info) => (
        <span className="text-xs text-gray-100">{info.getValue() as string}</span>
      ),
    }),
  )

  return (
    <div className="flex flex-col overflow-x-scroll scrollbar">
      <div className="flex-1 w-full relative space-y-4 mt-20">
        <div className="flex justify-between">
          <h2 className="grow text-lg font-bold text-black-700 w-full">
            {t('end_users.preview')}
          </h2>
          <p className="w-full flex justify-end">
            {t('end_users.data_rows')}&nbsp;<strong>{totalRows}</strong>
          </p>
        </div>

        <DataTable
          columns={columns}
          data={csvPreview.rows}
          className="border border-ui rounded-lg shadow-md"
        />
      </div>
    </div>
  )
}

export default CSVPreview
